import React, { FC } from 'react';
import cn from 'classnames';
import { useNotExistInCatalogKeys } from 'domains/ReportBuilder/model/selectors';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CleanSvg } from 'assets/clean.svg';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import Load from 'components/UI/Load';
import css from './styles.module.scss';

interface ISelectedContainerProps {
  label: string;
  isOpen: boolean;
  values: string[];
  onCleanField: () => void;
}

const SelectedContainer: FC<ISelectedContainerProps> = ({
  label,
  isOpen,
  values,
  onCleanField,
}) => {
  const { t } = useTranslation();
  const { isLoading: notExistKeysLoading } = useNotExistInCatalogKeys();

  const LIMIT_VIEW = 2;
  const visibleValues = values.slice(0, LIMIT_VIEW);
  const hiddenCount = Math.max(values.length - LIMIT_VIEW, 0);
  const filteredVisibleValues = visibleValues.filter((value) => value !== '');

  return (
    <div
      className={cn(css.container, {
        isOpen,
      })}
    >
      <div className={css.container_label}>{label}</div>
      <div className={css.grid_container}>
        <div
          className={cn(css.container_body, {
            _isLoading: filteredVisibleValues.length > 0 && notExistKeysLoading,
          })}
        >
          {filteredVisibleValues.length > 0 ? (
            <>
              {notExistKeysLoading ? (
                <Load
                  style={{
                    width: '100%',
                    height: '48px',
                  }}
                />
              ) : (
                filteredVisibleValues.map((value) => (
                  <div key={value} className={css.container_item}>
                    {value}
                  </div>
                ))
              )}

              {!notExistKeysLoading && hiddenCount > 0 && (
                <div className={cn(css.container_item, css.container_more)}>
                  +{hiddenCount}
                </div>
              )}
            </>
          ) : (
            <div className={css.container_empty}>
              {t(`project_page.forms.not_selected`)}
            </div>
          )}
        </div>
        {filteredVisibleValues.length > 0 && (
          <TooltipPoratal
            hint={t(`clean_btn`)}
            classname={css.clean}
            onClick={onCleanField}
          >
            <CleanSvg />
          </TooltipPoratal>
        )}
      </div>
    </div>
  );
};

export default SelectedContainer;
